import { is } from '@common/is/is'

import MatchMedia from '@common/MatchMedia/MatchMedia'

/**
 * Megmondja, hogy az adott eszköznek van-e érintőképernyős támogatása.
 * @see {@link https://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript}
 * @see {@link https://github.com/Modernizr/Modernizr/blob/master/feature-detects/touchevents.js}
 */
export default function isTouchSupported (): boolean {
  if (
    ('ontouchstart' in window) ||
    // @ts-expect-error A DocumentTouch-ra hörögne.
    (window.DocumentTouch && is.instanceOf(document, DocumentTouch)) ||
    // eslint-disable-next-line no-restricted-globals, no-restricted-properties -- Tényleg?
    navigator.maxTouchPoints > 0
  ) {
    return true
  }

  const prefixes: readonly string[] = [ '-webkit-', '-moz-', '-o-', '-ms-' ]

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = [ '(', prefixes.join('touch-enabled),('), 'heartz', ')' ].join('')

  // Ne haljunk bele, ha nincs matchmedia, akkor inkább dobjuk az egészet.
  if (!MatchMedia.isSupported()) {
    return false
  }

  const mm = MatchMedia.create(query)
  const matches = mm.isMatch()

  return matches
}
